import { useEffect } from 'react';
import { TourFlotante } from './TourFlotante';
import { registrarTour } from './registroTours';
import { EVENTO_CERRAR_TOUR } from './motorTour';
import { useTourGuiado } from './usarTour';
import { tourPrimeraVenta } from '@/features/tour/tourPrimeraVenta';

export function TourOverlay() {
  const {
    pasoActual,
    indicePaso,
    totalPasos,
    elementoObjetivo,
    avanzar,
    retroceder,
    omitir,
    finalizar,
    cerrarTour,
  } = useTourGuiado();

  useEffect(() => {
    registrarTour(tourPrimeraVenta);
  }, []);

  useEffect(() => {
    const handle = () => cerrarTour();
    window.addEventListener(EVENTO_CERRAR_TOUR, handle);
    return () => window.removeEventListener(EVENTO_CERRAR_TOUR, handle);
  }, [cerrarTour]);

  return (
    <TourFlotante
      paso={pasoActual}
      indicePaso={indicePaso}
      totalPasos={totalPasos}
      elementoObjetivo={elementoObjetivo}
      onSiguiente={avanzar}
      onAtras={retroceder}
      onOmitir={omitir}
      onFinalizar={finalizar}
    />
  );
}
